import React from 'react';
import Header from '../components/header';
import CompanyStats from '../components/companyStats';
import WhoWeAre from '../components/WhoWeAre';
import WhyChooseUs from '../components/WhyChooseUs';
import Services from './services';
import Technologies from '../components/Technologies';
import DevelopmentProcess from '../components/DevelopmentProcess';
import Project from './project';
import IndustriesWeServe from '../components/IndustriesWeServe';
import Testimonials from '../components/Testimonials';
import TeamSection from '../components/teammember';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import Contact from './contact';
import TrustedBy from '../components/trustBy';

const Home = () => {
  return (
    <div className="w-full bg-white dark:bg-[#080808] transition-colors duration-500">
      {/* 1. Hero Section */}
      <Header />
      
      {/* 2. Partners Marquee */}
      <TrustedBy />

      {/* 3. Who We Are */}
      <WhoWeAre />

      {/* 4. Company Stats Counter */}
      <CompanyStats />

      {/* 5. Services Grid */}
      <Services />

      {/* 6. Technologies Badges */}
      <Technologies />

      {/* 7. Why Choose Softkel Cards */}
      <WhyChooseUs />

      {/* 8. Development Sprints Timeline */}
      <DevelopmentProcess />

      {/* 9. Featured Projects Grid */}
      {/* <Project /> */}

      {/* 10. Industries We Support */}
      <IndustriesWeServe />

      {/* 11. Testimonials Slide Carousel */}
      <Testimonials />

      {/* 12. Meet the Team Leaderboard */}
      {/* <TeamSection /> */}

      {/* 13. FAQs Accordions */}
      <FAQ />

      {/* 14. Powerful Conversion Banner */}
      <CTA />

      {/* 15. Contact Glassmorphic Form */}
      <Contact />
    </div>
  );
};

export default Home;